import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { withToast } from "../App";
import { apiRequest } from "../utils/apiClient";

/**
 * Hook to access the API request functionality
 * @param {object} props - Props containing the addToast function
 * @returns {object} - Object with request function
 */
export const useApi = (props) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { addToast } = props || {};

    const request = useCallback(
        async (
            url,
            method = "GET",
            body = "",
            isUploadForm = false,
            csrfURL = "",
            firstRequest = false,
            errorHandler = {
                isHandlingError: () => false,
                handleError: () => {},
            },
        ) => {
            return apiRequest({
                url,
                method,
                body,
                isUploadForm,
                csrfURL,
                firstRequest,
                errorHandler,
                dependencies: {
                    navigate,
                    addToast,
                    t,
                    i18n,
                },
            });
        },
        [navigate, addToast, t, i18n],
    );

    return { request };
};

// HOC to provide the API hook with toast capabilities
export const withApi = (Component) => {
    const ApiComponent = withToast(useApi);
    const WithApi = (props) => {
        return (
            <ApiComponent>
                {(apiProps) => <Component {...props} api={apiProps} />}
            </ApiComponent>
        );
    };

    return WithApi;
};
